// extracted by mini-css-extract-plugin
export default {"searchBarWidth":"SearchBar_searchBarWidth__pVxh4"};